module.exports = __webpack_public_path__ + "img/PROTESIS_FIJA_MAL_ESTADO.png";